'use strict';
import angular from 'angular';
import './scripts/nightlystatus.ctrls';
import './scripts/nightlystatus.services';

import nightlyStatusHtmlUrl from './views/nightlyStatus.html';

angular.module('nightlystatus', [
    'nightlystatus.ctrls',
    'nightlystatus.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('nightlyStatus',   {
                parent: 'layout',
                url: '/admin/nightlyStatus',
                templateUrl: nightlyStatusHtmlUrl,
                controller: 'NightlyStatusController',
            })
    }]);